import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RemoveNullInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let newRequest: HttpRequest<any>;
        const reqBody = request.body;
        if (reqBody != null) {
            // Use `map` to get a new array with new objects
            for (const propName in reqBody) {
                if (
                    reqBody[propName] === null ||
                    reqBody[propName] === undefined ||
                    reqBody[propName] === ''
                ) {
                    delete reqBody[propName];
                }
            }
            newRequest = request.clone({
                body: reqBody
            });
        } else {
            newRequest = request.clone();
        }
        return next.handle(newRequest);
    }
}
